exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\niframe[data-v-058b719e] {\n  width: 100%;\n  height: 70vh;\n\n  border-width: 0;\n}\n.report-button[data-v-058b719e] {\n  background-color: green;\n}\n", ""]);
